import React from "react";
import { Button as MuiButton } from "@mui/material";

function ButtonBasic({
	name = "", // string
	children, // node
	classes, // object
	color = "primary", // 'inherit' | 'primary'| 'secondary'| 'success'| 'error'| 'info'| 'warning'
	component, // elementType
	disabled = false, // bool
	disableElevation = false, // bool
	disableFocusRipple = false, // bool
	disableRipple = false, // bool
	endIcon, // node
	fullWidth = false, // bool
	href = "", // string
	size = "medium", // 'small' | 'medium'| 'large'
	startIcon, // node
	sx, // object
	variant = "contained", // 'contained' | 'outlined'| 'text'
	onClick = () => {},
	onKeyUp = (e) => {},
	onKeyDown = (e) => {},
	onMouseUp = () => {},
	onMouseOver = () => {},
	onMouseDown = () => {},
	onMouseOut = () => {},
}) {
	const ClickBUtton = (e) => {
		onClick(e);
	};
	const KeyUpButton = (e) => {
		onKeyUp(e);
	};
	const KeyDownButton = (e) => {
		onKeyDown(e);
	};
	const MouseUp = () => {
		onMouseUp();
	};
	const MouseOver = () => {
		onMouseOver();
	};
	const MouseDown = () => {
		onMouseDown();
	};
	const MouseOut = () => {
		onMouseOut();
	};

	return (
		<MuiButton
			children={children}
			classes={classes}
			color={color}
			component={component}
			disabled={disabled}
			disableElevation={disableElevation}
			disableFocusRipple={disableFocusRipple}
			disableRipple={disableRipple}
			endIcon={endIcon}
			fullWidth={fullWidth}
			href={href}
			size={size}
			startIcon={startIcon}
			sx={sx}
			variant={variant}
			onClick={ClickBUtton}
			onKeyUp={KeyUpButton}
			onKeyDown={KeyDownButton}
			onMouseUp={MouseUp}
			onMouseOver={MouseOver}
			onMouseDown={MouseDown}
			onMouseOut={MouseOut}
			style={{ textTransform: "none" }}
		>
			{name}
		</MuiButton>
	);
}

export default React.memo(ButtonBasic);
